import { create } from "../../../common/utils/zustand_state_manager";
import { useEquipamentoMedicaoServices } from "./use_services";

import { IEquipamentoMedicaoRepository } from "../../../features/equipamentoMedicoes/domain/repositories/EquipamentoMedicao_Repositorie";
import { EquipamentoMedicaoRepository } from "../../../features/equipamentoMedicoes/data/repositories/EquipamentoMedicao_Repositorie";

/**
 * useAdministrationRepositories
 */

type State = {
  equipamentoMedicaoRepository: IEquipamentoMedicaoRepository,
};

export const useEquipamentoMedicaoRepository = create<State>((set, get) => {
  const { equipamentoMedicaoService } = useEquipamentoMedicaoServices.getState();
  return ({
    equipamentoMedicaoRepository: new EquipamentoMedicaoRepository(equipamentoMedicaoService),
  });
});